module.exports = __webpack_public_path__ + "static/media/Vector 316checked.4cfb45e3.svg";